// DropdownMenu.js
import React from 'react';
import Select from 'react-select';


const DropdownMenu = ({ filter, setFilter, copyToClipboard, exportToExcel, triggerBuild ,freeMemoryPercentageEDM,appstatusEDM}) => {

    const handleChange = (selectedOption) => {
        if (selectedOption) {
            window.open(selectedOption.value, '_blank');
        }
    }

    const options = [
        {label:"Auth deployment Plan",value:"https://confluence.us.bank-dns.com/pages/viewpage.action?pageId=656811103"},  
        { label: "JIRA Kanban Board", value: "https://jira.us.bank-dns.com/secure/RapidBoard.jspa?rapidView=16963&quickFilter=123462" },
        { label: "Test User Data", value: "https://confluence.us.bank-dns.com/pages/viewpage.action?spaceKey=CSWP&title=CDC+TEST+DATA" },
        { label: "Communication HUB", value: "https://communications-it.us.bank-dns.com/commhubeventlog/api/search?limit=1&toEmailMobileAddress=" },
        { label: "Shield Design System", value: "https://design-system.usbank.com/" },
        { label: "NPM Artifactory Setup", value: "https://wiki.us.bank-dns.com/index.php?title=Setting_up_NPM_with_Artifactory&title=Setting_up_NPM_with_Artifactory" },
        { label: "Servicing API Design", value: "https://confluence.us.bank-dns.com/display/CSWP/Servicing" },
        { label: "New Incident", value: "https://itsmnow.service-now.com/mytech?id=sc_cat_item&sys_id=3dba2a841b3ea1503023ecaa234bcb19&sysparm_category=fff93bbfdb369b408c910ef5b9961926" },
        { label: "ASAE Aegis Report", value: "https://asae.us.bank-dns.com/ISSAppSecPortal/SecurityCheck" },
    ];

    return (
        <div className='input-group'>

            <input
                type="text"
                placeholder="Search..."
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                style={{ marginBottom: '10px', padding: '5px' }}
            />
            &nbsp;
            <button onClick={copyToClipboard} className='mybutton'>Mail Scan Report</button>
            <button onClick={exportToExcel} className='mybutton'>Export Data</button>
            <button onClick={triggerBuild} className='mybutton'>Build and Re-Scan</button>

            <Select
                options={options}
                onChange={handleChange}
                placeholder="Select a site..."
                className="react-select-container"
                classNamePrefix="react-select" />

{appstatusEDM=="UP"?(<>
    <div className="server-status-up">
     <span className="server-up"><button className={"play-button-active"}>&#128187;</button>EDM-{freeMemoryPercentageEDM||"UP"}</span>
  </div>
     
</>):(
<div className="server-status">
    <span className="server-down"><button className="play-button-down">&#128187;</button><br></br>EDM</span>
  </div>) 
}
               

        </div>
    );
};

export default React.memo(DropdownMenu);